import { Head, Form, Link } from '@inertiajs/react'
import { Button } from '@/components/ui/Button'
import { Card } from '@/components/ui/Card'
import { Field } from '@/components/ui/Field'

type Labels = {
  title: string
  name: string
  address: string
  contact_email: string
  contact_phone: string
  notes: string
  submit: string
  submit_processing: string
  back_link: string
}

type Props = {
  labels: Labels
}

export default function EstablishmentsNew({ labels }: Props) {
  return (
    <>
      <Head title={labels.title} />
      <div className="mx-auto max-w-xl px-4 py-10 sm:px-6 lg:px-8">
        <Link href="/establishments" className="text-sm font-semibold text-ink-soft hover:text-ink">
          {labels.back_link}
        </Link>
        <h1 className="mt-4 font-display text-3xl text-ink">{labels.title}</h1>

        <Card className="mt-6 p-6 sm:p-8">
          <Form method="post" action="/establishments" className="space-y-5">
            {({ errors, processing }) => (
              <>
                <Field label={labels.name} name="name" type="text" required autoFocus error={errors.name} />
                <Field label={labels.address} name="address" type="text" error={errors.address} />
                <Field label={labels.contact_email} name="contact_email" type="email" error={errors.contact_email} />
                <Field label={labels.contact_phone} name="contact_phone" type="tel" error={errors.contact_phone} />
                <Field label={labels.notes} name="notes" multiline rows={3} error={errors.notes} />

                <Button type="submit" disabled={processing} className="w-full disabled:opacity-60">
                  {processing ? labels.submit_processing : labels.submit}
                </Button>
              </>
            )}
          </Form>
        </Card>
      </div>
    </>
  )
}
